<template>
  <TitlePage
    class="page-edit-user"
    :title="lang.title"
    @back="$emit('back')"
    @commit="commit"
  >
    <div class="page-edit-user-header">
      <div class="avatar" @click="upload">
        <Avatar
          class="back"
          username="default"
          :src="img"
          :size="100"
        ></Avatar>
        <div class="mask"></div>
      </div>
      <div class="text" @click="upload">上传照片</div>
      <input
        id="page-edit-user-upload-avatar"
        class="invisible" type="file" accept="*/*"
        @change="updateTempImg">
    </div>
    <div class="page-edit-user-body">
      <div class="page-edit-user-body-box">
        <div class="page-edit-user-input-title">{{lang.input.name}}</div>
        <div class="page-edit-user-input">
          <BaseInput
            v-model.trim="input.name"
            :placeholder="lang.input.name"
          ></BaseInput>
        </div>
        <div class="page-edit-user-input-title">{{lang.input.title}}</div>
        <div class="page-edit-user-input">
          <BaseInput
            v-model.trim="input.title"
            :placeholder="lang.input.title"
            icon="icon-pr_phone_arrow_edit_open"
            iconFloat="right"
            @icon="showTitleDropdown=!showTitleDropdown"
          ></BaseInput>
        </div>
        <div class="page-edit-user-input-title">{{lang.input.loc}}</div>
        <div class="page-edit-user-input">
          <InputBlock
            icon="icon-pr_phone_arrow_edit_open"
            iconFloat="right"
            @click="clickLocDropdownIcon"
          >
            <div class="value">
              <span>{{input.province}}</span>
              <span>{{input.city}}</span>
            </div>
          </InputBlock>
        </div>
      </div>
    </div>
    <div class="page-edit-user-dropdown" v-if="showTitleDropdown">
      <div class="page-edit-user-dropdown-header">
        <div @click="cancel" class="button cancel">取消</div>
        <div @click="updateTitle" class="button confirm">确定</div>
      </div>
      <pd-select-box>
        <pd-select-item :listData="dataTitleForSelect" v-model.trim="temp.title"></pd-select-item>
      </pd-select-box>
    </div>
    <div class="page-edit-user-dropdown" v-if="showLocDropDown">
      <div class="page-edit-user-dropdown-header">
        <div @click="cancel" class="button cancel">取消</div>
        <div @click="updateLoc" class="button confirm">确定</div>
      </div>
      <pd-select-box>
        <pd-select-item :listData="dataProvinceForSelect" v-model.trim="temp.province"></pd-select-item>
        <pd-select-item v-if="preventCitySelectItem" :listData="dataCityForSelect" v-model.trim="temp.city"></pd-select-item>
        <pd-select-item v-if="!preventCitySelectItem" :listData="dataCityForSelect" v-model.trim="temp.city"></pd-select-item>
      </pd-select-box>
    </div>
  </TitlePage>
</template>

<script>
import _ from 'lodash'
import { dcV2Graphql } from '@/api'

import { Avatar } from 'vue-avatar'
import {
  pdSelectBox,
  pdSelectItem
} from 'pd-select'
import TitlePage from './TitlePage.vue'

import { BaseInput } from '../input'
import { BaseDropdown } from '../dropdown'
import { InputBlock } from '../block'

export default {
  components: {
    Avatar,
    pdSelectBox,
    pdSelectItem,
    TitlePage,
    BaseInput,
    BaseDropdown,
    InputBlock
  },
  props: {
    title: {
      type: String
    },
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    lang: {
      type: Object,
      default () {
        return {
          title: '编辑基本信息',
          input: {
            name: '姓名',
            title: '职称',
            loc: '城市'
          }
        }
      }
    }
  },
  data () {
    return {
      input: {
        name: _.get(this.data, 'card.name'),
        title: _.get(this.data, 'card.title'),
        province: _.get(this.data, 'province'),
        city: _.get(this.data, 'city'),
        img: null,
        imgForAvatar: null
      },
      temp: {
        title: _.get(this.data, 'card.title'),
        province: _.get(this.data, 'province'),
        city: _.get(this.data, 'city')
      },
      showTitleDropdown: false,
      showLocDropDown: false,
      dataTitle: [
        {value: 'CEO', label: 'CEO'},
        {value: 'CFO', label: 'CFO'},
        {value: 'CTO', label: 'CTO'}
      ],
      dataProvince: [],
      preventCitySelectItem: true
    }
  },
  computed: {
    img () {
      if (this.input.imgForAvatar) {
        return this.input.imgForAvatar
      }
      let img = _.get(this.data, 'card.head_image_url')
      if (img) {
        return img
      }
      return 'http://az.img.nutsbp.com/007/image/nuts_dartcome/pc/pr/cut_page/pr_default_image_big.png'
    },
    dataCity () {
      let i = _.findIndex(this.dataProvince, {label: this.temp.province})
      if (i === -1) {
        i = 0
      }
      let d = this.dataProvince[i].data
      if (d) {
        return d
      }
      return []
    },
    dataTitleForSelect () {
      return this.dataTitle.map(row => {
        return row.label
      })
    },
    dataProvinceForSelect () {
      return this.dataProvince.map(row => {
        return row.label
      })
    },
    dataCityForSelect () {
      return this.dataCity.map(row => {
        return row.label
      })
    }
  },
  methods: {
    cancel () {
      this.temp.title = null
      this.temp.province = null
      this.temp.city = null

      this.showTitleDropdown = false
      this.showLocDropDown = false
    },
    updateTitle () {
      let k
      k = 'title'
      if (this.temp[k]) {
        let o = _.find(this.dataTitle, {label: this.temp[k]})
        this.input[k] = o.value
        this.temp[k] = null
      }
      this.showTitleDropdown = false
    },
    updateLoc () {
      let k
      k = 'province'
      this.showLocDropDown = false
      if (this.temp[k]) {
        this.input[k] = this.temp[k]
      }
      k = 'city'
      if (this.temp[k]) {
        let o = _.find(this.dataCity, {label: this.temp[k]})
        if (o) {
          this.input[k] = this.temp[k]
        } else {
          this.input[k] = null
        }
      }
    },
    close () { this.$emit('close') },
    commit () { this.$emit('commit', this.input) },
    /**
     * 上传图片相关
     */
    upload (event) {
      document.getElementById('page-edit-user-upload-avatar').click()
    },
    async updateTempImg (event) {
      let oFile = event.target.files[0]
      if (!oFile || !oFile.type) {
        throw new Error('请选择正确格式')
      }
      let mb = 10
      let iMaxFilesize = 1048576 * mb
      if (oFile.size > iMaxFilesize) {
        throw new Error(`档案尺寸超出 ${mb}MB 上限`)
      }
      this.input.img = oFile
      let reader = new FileReader()
      reader.onload = e => {
        this.input.imgForAvatar = e.target.result
      }
      reader.readAsDataURL(oFile)
    },
    async clickLocDropdownIcon () {
      if (this.dataProvince.length <= 0) {
        this.dataProvince = await this.fetchProvinceCity()
      }
      this.showLocDropDown = !this.showLocDropDown
    },
    async fetchProvinceCity () {
      let res = await dcV2Graphql.post('/', {
        query: `query Query { chinaProvinceCityData }`
      })
      let data = _.get(res, 'data.data.chinaProvinceCityData')
      if (!data) {
        throw new Error('query chinaProvinceCityData failed')
      }
      let dataFixed = data.map((row, i) => {
        return {
          index: i,
          value: row.provinceName,
          label: row.provinceName,
          data: row.cityInfoList.map((row, i) => {
            return {
              index: i,
              label: row.name,
              value: row.name
            }
          })
        }
      })
      return dataFixed
    }
  },
  watch: {
    'temp.province' (newV, oldV) {
      if (newV === oldV) {
        return
      }
      this.preventCitySelectItem = !this.preventCitySelectItem
      this.temp.city = null
    }
  }
}
</script>

<style lang="postcss" scoped>
@import "index.css";
.page-edit-user {
  & .page-edit-user-header {
    position: relative;
    margin: auto;
    @media (--mediaPc) {
      padding: 50px 0;
    }
    @media (--mediaMobile) {
      padding: calc(50px / var(--scaleMobile)) 0;
    }
    & .avatar {
      position: relative;
      margin: auto;
      height: 110px;
      width: 110px;
      border: 1px solid var(--colorDisabled);
      border-radius: 100px;
      & .back {
        position: absolute;
        top: 5px;
        left: 5px;
      }
      & .mask {
        position: absolute;
        top: 5px;
        left: 5px;
        margin: auto;
        width: 100px;
        height: 100px;
        border-radius: 100px;
        background-color: rgba(0, 0, 0, .5);
      }
    }
    & .text {
      position: absolute;
      text-align: center;
      width: 100%;
      top: 75px;
      color: var(--colorWhite);
      @media (--mediaPc) {
        font-size: var(--textSize4);
      }
      @media (--mediaMobile) {
        font-size: var(--textSize4Mobile);
      }
    }
  }
  & .page-edit-user-body {
    position: relative;
    & .page-edit-user-body-box {
      position: relative;
      margin: auto;

      @media (--mediaPc) {
        width: 640px;
      }
      @media (--mediaMobile) {
        width: calc(640px / var(--scaleMobile));
      }
      & .page-edit-user-input {
        display: inline-block;
        padding-top: 10px;
        padding-bottom: 25px;
        width: 100%;

        @media (--mediaPc) {
          height: 98px;
        }
        @media (--mediaMobile) {
          height: calc(98px / var(--scaleMobile));
        }
        & .value {
          padding-top: 15px;
        }
      }
      & .page-edit-user-input-title {
        @media (--mediaPc) {
          font-size: var(--textSize4);
        }
        @media (--mediaMobile) {
          font-size: var(--textSize4Mobile);
        }
      }
    }
  }
  & .page-edit-user-dropdown {
    position: fixed;
    bottom: 0;
    width: 100%;
    & .page-edit-user-dropdown-header {
      background-color: var(--color8);
      height: 49px;
      & .button {
        position: absolute;

        @media (--mediaPc) {
          padding: 36px 40px;
          font-size: var(--textSize3);
        }
        @media (--mediaMobile) {
          padding: calc(36px / var(--scaleMobile)) calc(40px / var(--scaleMobile));
          font-size: var(--textSize3Mobile);
        }
        &.cancel {
          left: 0;
          color: var(--color5)
        }
        &.confirm {
          right: 0;
          color: var(--color1);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/page/EditUserPage.vue